import MemberProgramSettings from '@/assets/ts/interfaces/MemberProgramSettings'
import ProgramStore from '@/assets/ts/interfaces/ProgramStore'
import Session from '@/assets/ts/interfaces/Session'
import Workout from '@/assets/ts/interfaces/Workout'
import getProgram from '@/assets/ts/programs/getProgram'

const useStoreProgramNew = defineStore( 'programStore', () => {

  const profileStore = useStoreProfile()

  const program = useStorage<ProgramStore>( 'program', {
    program: null,
    workoutWeekNumber: 0,
    programStartDate: null,
    completedSessions: [],
  } )

  const memberProgramSettings = ref<MemberProgramSettings|null>( null )
  const equipmentAvailable = computed( () => memberProgramSettings.value?.values.find( setting => setting.name === 'equipmentAvailable' ) )
  const equipmentOptions = computed( () => equipmentAvailable.value?.values )
  const equipmentOptionsWithoutDbBands = computed( () => profileStore.profile.equipmentAvailable === 'db-bands' ? equipmentOptions.value : equipmentOptions.value?.filter( option => option.value !== 'db-bands' ) )

  const getMemberProgramSettings = async ( memberId: number ) =>
    Http.get( `/member/${memberId}/program-settings` )

  const remainingWorkouts = computed( () => {
    if ( program.value.program && program.value.workoutWeekNumber ) {
      return program.value.program.workouts.filter( ( workout: Workout ) =>
        workout.weekNumbers.includes( program.value.workoutWeekNumber )
        && ! program.value.completedSessions.find( ( session: Session ) => session.workout.ID === workout.ID ) )
    } else {
      return []
    }
  } )

  const fetchProgramFromDatabase = async ( programId: number ) => {
    try {
      const response = await getProgram( programId )
      console.log( 'Fetched program:', response )
      program.value.program = response
    } catch ( error ) {
      console.error( 'Failed to fetch program:', error )
    }
  }

  const initializeProgram = async ( programId: number ) => {
    if ( ! program.value.program ) {
      await fetchProgramFromDatabase( programId )
    }
    memberProgramSettings.value = await Http.get( `/member/${store.state.profile.ID}/program-settings` )
  }

  return {
    equipmentOptions,
    equipmentOptionsWithoutDbBands,
    program,
    memberProgramSettings,
    initializeProgram,
  }
} )

export default useStoreProgramNew